$(function() {

    // Search Form
    $('.menu-dalles .menu-item a.unclickable').off('click').on('click', (e) => {

        e.preventDefault();

        let menu_item = e.target.id;

        $('.page-navigation #submenu-item').empty();

        $('.page-navigation #submenu-item').append('<h3>' + e.target.innerText + '</h3>');

        $('.page-navigation .submenu#'+menu_item ).clone().appendTo( '.page-navigation #submenu-item' );

        $('.page-navigation #submenu-item .submenu').removeClass('d-none');

        $('html,body').animate({
            scrollTop: $( '.page-navigation #submenu-item' ).offset().top - 100
        }, 500);

    });

});

